import { collectionGroup, DocumentData, FirestoreDataConverter, getDocs, limit, orderBy, query } from 'firebase/firestore'
import FirebaseService from '@/services/FirebaseService'
import { Service } from './service'

export const WORK_ORDER_STATUS = {
  DRAFT: 'draft', // created
  OPEN: 'open', // emailed to sub
  PENDING_APPROVAL: 'pending_approval', // waiting for admin to approve
  CLOSED: 'closed' // bill paid
}

const getLastWorkOrderId = async () => {
  const db = await FirebaseService.firestore()
  const collectionRef = collectionGroup(db, 'workOrders')
  const queryRef = query(collectionRef, orderBy('workOrderId', 'desc'), limit(1))
  const querySnapshot = await getDocs(queryRef)

  if (querySnapshot.empty) return '1000'

  const workOrder = Object.assign({}, querySnapshot.docs[0].data())
  return workOrder.workOrderId ? workOrder.workOrderId.substring(4) : '1000'
}
export class WorkOrderItem extends Service {
  lineItems: string[]

  constructor () {
    super()

    this.lineItems = []
  }
}

export class WorkOrder {
  id: string
  workOrderId: string
  subId: string
  budgetId: string
  projectId: string
  status: string
  lineItems: string[]
  items: WorkOrderItem[]
  total: number
  attachments: []
  date: Date
  submittedBy: string // userId
  approvedBy: string // userId
  createdAt: Date
  updatedAt: Date

  constructor () {
    this.workOrderId = ''
    this.subId = ''
    this.budgetId = ''
    this.projectId = ''
    this.status = WORK_ORDER_STATUS.OPEN
    this.lineItems = []
    this.items = []
    this.total = 0
    this.attachments = []
    this.date = new Date()
    this.submittedBy = ''
    this.approvedBy = ''
    this.createdAt = new Date()
    this.updatedAt = new Date()
  }
}

export const generateWorkOrderId = async () => {
  const lastWorkOrderId = await getLastWorkOrderId()
  const label = 'WO'
  const year = new Date().getFullYear().toString().substring(2)
  const counter = parseInt(lastWorkOrderId)
  return `${label}${year}${counter + 1}`
}

export const workOrderConverter: FirestoreDataConverter<WorkOrder, DocumentData> = {
  toFirestore: (workOrder: WorkOrder) => {
    const wOrder = JSON.parse(JSON.stringify(workOrder)) as WorkOrder
    wOrder.total = typeof wOrder.total === 'string' ? parseFloat(wOrder.total) : wOrder.total
    wOrder.items.forEach((item) => {
      item.cost = typeof item.cost === 'string' ? parseFloat(item.cost) : item.cost
    })
    wOrder.createdAt = wOrder.createdAt ? new Date(wOrder.createdAt) : new Date()
    wOrder.updatedAt = new Date()
    return Object.assign({}, wOrder)
  },

  fromFirestore: (snapshot, options) => {
    const data = snapshot.data(options)
    data.date = (typeof data.date === 'object') ? data.date.toDate() : data.date
    data.createdAt = (typeof data.createdAt === 'object') ? data.createdAt.toDate() : data.createdAt
    data.updatedAt = (typeof data.updatedAt === 'object') ? data.updatedAt.toDate() : data.updatedAt
    return Object.assign(new WorkOrder(), data) as WorkOrder
  }
}
